export default {"src":"/_next/static/media/check-icon.38c7e69f.svg","height":21,"width":29,"blurWidth":0,"blurHeight":0};